import React from 'react';
import ErpTablePage from '../components/ErpTablePage';
import ErpDocPage from '../components/ErpDocPage'

const VendorPayments = () => {
  return <ErpDocPage moduleKey="vendor_payments" />;
};

export default VendorPayments;